module.exports = __webpack_public_path__ + "img/about us.33298382.png";